import repository from "../Repository";

export default {
  get(screenId) {
    return repository.post(
      `dpnd/dpnd-auth-info`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
